export default [
	{
		name: 'Todos os anunciantes',
		value: '',
	},
	{
		name: 'Acessórios',
		value: 'Acessórios',
	},
	{
		name: 'Bebidas',
		value: 'Bebidas',
	},
	{
		name: 'Brinquedos',
		value: 'Brinquedos',
	},
	{
		name: 'Calçados',
		value: 'Calçados',
	},
	{
		name: 'Cama, Mesa e Banho',
		value: 'Cama, Mesa e Banho',
	},
	{
		name: 'Camping',
		value: 'Camping',
	},
	{
		name: 'Decoração',
		value: 'Decoração',
	},
	{
		name: 'Eletrodomésticos',
		value: 'Eletrodomésticos',
	},
	{
		name: 'Eletrônicos',
		value: 'Eletrônicos',
	},
	{
		name: 'Enxovais',
		value: 'Enxovais',
	},
	{
		name: 'Jardinagem',
		value: 'Jardinagem',
	},
	{
		name: 'Materiais de Construção',
		value: 'Materiais de Construção',
	},
	{
		name: 'Moda Feminina',
		value: 'Moda Feminina',
	},
	{
		name: 'Moda Fitness',
		value: 'Moda Fitness',
	},
	{
		name: 'Moda Infantil',
		value: 'Moda Infantil',
	},
	{
		name: 'Moda Masculina',
		value: 'Moda Masculina',
	},
	{
		name: 'Moda Plus Size',
		value: 'Moda Plus Size',
	},
	{
		name: 'Moda Praia',
		value: 'Moda Praia',
	},
	{
		name: 'Móveis',
		value: 'Móveis',
	},
	{
		name: 'Personalização',
		value: 'Personalização',
	},
	{
		name: 'PetShop',
		value: 'PetShop',
	},
	{
		name: 'Sex Shop',
		value: 'Sex Shop',
	}
]












